import CloseIcon from "@mui/icons-material/Close";
import CommentIcon from '@mui/icons-material/Comment';
import UploadIcon from '@mui/icons-material/Upload';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { Badge, Card, Grid, IconButton, Switch, Tooltip } from "@mui/material";
import { Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import Prompt from "components/UpStyled/Prompt";
import { AccountContext } from "context/account";
import { nanoid } from "nanoid";
import Sketch, { AnnotationColors, EditComments, SketchToolTip } from "pages/de/styles/detail/components/DevelopStage/Sketch";
import qs from "query-string";
import { useContext, useEffect, useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import toast from "react-hot-toast";
import api from "services/api";
import { getImageDimensions } from "utils/imageHelper";

var deepEqual = require('deep-equal')

const FileBoard = ({ detail, currentFile, setCurrentFile, referenceFiles, setReferenceFiles, commentsList, projectid, editable, refreshComments, getNextIndex, account }) => {
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false)
  const [sketchHeight, setSketchHeight] = useState(400);
  const [currentComment, setCurrentComment] = useState(null);
  const [commentsDialogVisible, setCommentsDialogVisible] = useState(false);
  const [color, setColor] = useState('Black');
  const [showComments, setShowComments] = useState(commentsList.length > 0);
  const [method, setMethod] = useState('comments');

  const sketchTooltipRef = useRef(null)
  const setSketchToolTip = (tooltip) => {
    if (sketchTooltipRef.current) sketchTooltipRef.current.setSketchToolTip2(tooltip)
  };

  useEffect(() => {
    setShowComments(commentsList.length > 0)
  }, [commentsList]);

  const updateRotation = (id, rotation) => {
    const nextDatas = referenceFiles.map((f) => {
      if (f.id === id) {
        return { ...f, rotation: rotation }
      } else {
        return f;
      }
    });
    //console.log('referenceFiles', referenceFiles, id, rotation, nextDatas)
    setReferenceFiles(nextDatas);
    setCurrentFile({ ...currentFile, rotation: rotation })
  }

  //console.log('currentFile', currentFile)
  commentsList.sort(((a, b) => (a.index < b.index ? -1 : 1)))
  const smartdate = require("smartdate");
  smartdate.init();
  return (currentFile ?
    <Card sx={{ p: 1, height: "100%", width: "100%" }}>
      <Prompt
        heading="Delete Confirmation"
        text={"Are you sure you want to delete this sample image?"}
        visible={deleteDialogVisible}
        okText="Delete"
        okColor="dark"
        handleOk={() => {
          var newDatas = referenceFiles.filter((s) => s.id !== currentFile.id)
          setReferenceFiles(newDatas)
          setDeleteDialogVisible(false)
          setCurrentFile(newDatas.length > 0 ? newDatas[0] : null)
        }}
        handleClose={() => setDeleteDialogVisible(false)}
      />
      <SuiBox sx={{ mb: 0, flexWrap: "wrap" }} display="flex" alignItems="center">
        <SuiBox sx={{ px: 1, borderLeft: '2px solid #E0E0E0' }} display="flex" alignItems="center">
          <AnnotationColors color={color} setColor={setColor} />
        </SuiBox>
        <SuiBox sx={{ px: 1, borderLeft: '2px solid #E0E0E0' }} display="flex" alignItems="center">
          <Tooltip title={`Add comments on top of image`} placement="top-start">
            <IconButton
              sx={{ mx: 0 }}
              size="inherit"
              style={method == "comments" ? { backgroundColor: 'LightGrey' } : {}}
              onClick={() => {
                if (method !== "comments") {
                  setMethod("comments");
                  setShowComments(true);
                } else
                  setMethod('')
              }}
            >
              <CommentIcon
                fontSize="inherit"
                style={{ color: color }}
                className="border-none hover:bg-transparent"
              />
            </IconButton>
          </Tooltip>
          {false &&
            <SuiButton
              sx={{ mx: 0, my: 0, p: 0, textTransform: 'none' }}
              color="dark"
              variant="text"
              onClick={(e) => { setMethod("comments"); setShowComments(true); }}
            >
              Add<br />Comments
            </SuiButton>
          }
          <Switch sx={{ mx: 1 }} checked={showComments} onChange={() => setShowComments(!showComments)} />
          <SuiButton
            sx={{ mx: 0, my: 0, p: 0, textTransform: 'none' }}
            color="dark"
            variant="text"
            onClick={(e) => { setShowComments(!showComments) }}
          >
            {showComments ? "Hide" : "Show"}<br />Comments
          </SuiButton>
        </SuiBox>
        <SuiBox sx={{ px: 1, borderLeft: '2px solid #E0E0E0' }} display="flex" alignItems="center">
          <Tooltip title={`Increase image height from ${sketchHeight} to ${sketchHeight + 100} pixels`} placement="top-start">
            <IconButton
              sx={{ mx: 0 }}
              size="medium"
              onClick={() => {
                setSketchHeight(sketchHeight + 100)
              }}
            >
              <ZoomInIcon
                fontSize="medium"
                color="inherit"
                className="border-none hover:bg-transparent"
              />
            </IconButton>
          </Tooltip>
          <Tooltip title={`Decrease image height from ${sketchHeight} to ${sketchHeight > 200 ? sketchHeight - 100 : sketchHeight} pixels`} placement="top-start">
            <IconButton
              sx={{ mx: 0 }}
              size="medium"
              onClick={() => {
                if (sketchHeight > 200) setSketchHeight(sketchHeight - 100)
              }}
            >
              <ZoomOutIcon
                fontSize="medium"
                color="inherit"
                className="border-none hover:bg-transparent"
              />
            </IconButton>
          </Tooltip>
        </SuiBox>
      </SuiBox>
      <Grid container spacing={2} sx={{ pt: 5 }}>
        <Grid item xs={12} sm={showComments ? 8 : 12} md={showComments ? 8 : 12}>
          <SuiBox className="flex flex-row" sx={{ width: '100%' }} style={{ overflowX: 'auto', overflowY: "hidden" }}>
            <Sketch detail={detail} board={null} editable={editable} sketchdata={currentFile} sketchcomments={commentsList} sketchHeight={sketchHeight} color={color} method={method} updateLines={null} refreshComments={refreshComments} updateImageRatio={null} updateRotation={updateRotation} tableFields={null} setIsDragDisabled={null} setImageFilter={null} setDeleteImage={null} setDeleteImgDialogVisible={setDeleteDialogVisible} sketchDatas={null} imageFilter={null} showComments={showComments} setSketchToolTip={setSketchToolTip} getNextIndex={getNextIndex} />
          </SuiBox>
        </Grid>
        {showComments && <Grid item xs={12} sm={4} md={4}>
          <Card sx={{ borderRadius: 2 }}>
            <EditComments comments={currentComment} account={account} commentsDialogVisible={commentsDialogVisible} setCommentsDialogVisible={setCommentsDialogVisible} refreshComments={refreshComments} detail={detail} board={null} />
            <SuiBox sx={{ height: sketchHeight + 37 }}>
              <SuiBox sx={{ display: "flex", justifyContent: "space-between" }} alignItems="center">
                <SuiTypography variant="h6" sx={{ ml: 1 }} >Comments:</SuiTypography>
                <IconButton
                  aria-label="close"
                  onClick={() => setShowComments(false)}
                  sx={{
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </SuiBox>
              <ul style={{ overflowY: "auto", maxHeight: sketchHeight }}>
                {commentsList.length == 0 &&
                  <SuiTypography variant="body1" sx={{ m: 1 }} >Tips: select "Add Comments" and click on image to create a new Comment entry</SuiTypography>
                }
                {commentsList.map((sc) => (
                  <SuiBox key={sc.index} sx={{ m: 1 }}>
                    <a onClick={() => {
                      setCurrentComment(sc)
                      setCommentsDialogVisible(true)
                    }}
                    >
                      <SuiTypography variant="button"
                        className={`block text-gray-600`} >
                        #{sc.index}
                      </SuiTypography>
                      <SuiBox display="flex" justifyContent="center" alignItems="center" >
                        <Badge variant="dot" color="error" invisible={!sc.newcomments}>
                          <ContactAvatar room={sc} />
                        </Badge>
                        <div className="w-full pb-2 ml-1">
                          <div className="flex justify-between items-center">
                            <SuiTypography
                              className={`text-gray-600`}
                              variant="body1"
                              textTransform="none"
                              sx={{
                                width: "100%",
                                minHeight: "16px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: "1",
                                WebkitBoxOrient: "vertical",
                              }}>
                              {sc.content ?? ' '}
                            </SuiTypography>
                          </div>
                          <div className="flex justify-between items-center">
                            <SuiTypography variant="caption" >
                              {sc.commentCnts ?? 0} Comments
                            </SuiTypography>
                            <SuiTypography variant="caption" >
                              {smartdate.format(new Date(sc.timestamp))}
                            </SuiTypography>
                          </div>
                        </div>
                      </SuiBox>
                    </a>
                  </SuiBox>
                ))}
              </ul>
            </SuiBox>
          </Card>
        </Grid>
        }
      </Grid >
      <SuiBox className="flex flex-row" sx={{ width: '100%', pb: 0 }}>
        <SketchToolTip ref={sketchTooltipRef} color={color} method={method} />
      </SuiBox>
    </Card > : <></>
  );
};


const ReferencesStage = ({ detail, handleRefresh, accountType, imgid }) => {
  var files = detail?.style.referenceFiles ?? []
  var initImg = files.filter((f) => f.id === imgid)
  const [referenceFiles, setReferenceFiles] = useState(files);
  const [currentFile, setCurrentFile] = useState(initImg.length == 1 ? initImg[0] : (files.length > 0 ? files[0] : null))
  const [sketchComments, setSketchComments] = useState({});

  var account = useContext(AccountContext);
  var editable = (account.id === detail.store_id)
  const referenceFilesRef = useRef(null);
  referenceFilesRef.current = referenceFiles;
  const urlObj = qs.parseUrl(location.href ? location.href : location.pathname + location.search);
  var projectid = urlObj?.query.pid ?? "";
  const indexHtmlRef = useRef(null)
  const saveTSRef = useRef(new Date());

  useEffect(() => {
    //console.log('ReferencesStage useEffect')
    refreshComments()
  }, []);

  useEffect(() => {
    saveReferenceFiles(true)
  }, [referenceFiles]);

  const refreshComments = () => {
    if (referenceFiles.length == 0) {
      return
    }
    var sketchids = referenceFiles.map((s) => s.id)
    try {
      api.comment.sketch_get({ sketchids: sketchids, product_id: detail.id }).then(({ data }) => {
        const newSketchComments = {}
        for (var sketchcomment of data.sketchcomments) {
          sketchcomment.startX = sketchcomment.metadata.startX ?? NaN
          sketchcomment.startY = sketchcomment.metadata.startY ?? NaN
          sketchcomment.endX = sketchcomment.metadata.endX
          sketchcomment.endY = sketchcomment.metadata.endY
          sketchcomment.color = sketchcomment.metadata.color
          sketchcomment.index = sketchcomment.metadata.index
          sketchcomment.method = "comments"
          sketchcomment.newcomments = sketchcomment.latestcommentts && sketchcomment.latestcommentts > (sketchcomment.viewcommentts[account.id] ?? "")
          if (!(sketchcomment.sketch_id in newSketchComments))
            newSketchComments[sketchcomment.sketch_id] = []
          newSketchComments[sketchcomment.sketch_id].push(sketchcomment)
        }
        setSketchComments(newSketchComments)
        return data;
      });
    } catch (err) {
      toast.error("load sketch comments failed!");
      console.log(err);
    }
  }

  const saveReferenceFiles = async (autosave) => {
    //console.log('detail.style.referenceFiles', detail.style.referenceFiles)
    //console.log('referenceFiles', referenceFilesRef.current)
    if (editable && !deepEqual(detail.style.referenceFiles, referenceFilesRef.current)) {
      saveTSRef.current = new Date()
      try {
        const payload = {
          style: {
            ...detail?.style,
            referenceFiles: referenceFilesRef.current,
          },
        };
        await api.products.update(detail.id, payload);
        toast.success((autosave ? "Auto s" : "S") + "ave sample files successfully!");
        detail.style.referenceFiles = referenceFilesRef.current
      } catch (err) {
        console.log(err);
        toast.error("Save sample files failed!");
      }
    }
  }

  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return
    var updatedList = [...referenceFiles]
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1)
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem)
    setReferenceFiles(updatedList)
  };

  const handleUpload = async ({ file }) => {
    var rid = nanoid()
    var file2 = new File([file], rid + "_" + file.name, { type: file.type });
    const url = await api.uploads.create([file2]).then(({ data }) => {
      const uploaded = data.uploads.map(({ url }) => url);
      return uploaded;
    });
    if (url && url.length == 1) {
      try {
        const { width, height } = await getImageDimensions(url)
        var newFile = { id: rid, name: file.name, type: file.type, imgurl: url, height: height, width: width }
        setReferenceFiles(oldData => [...oldData, newFile]);
        setCurrentFile(newFile)
      }
      catch (err) {
        console.log(err);
        toast.error("File can not be processed due to incompatible format!");
      }
    }
  };

  const getNextIndex = () => {
    var indexArray = []
    for (var file of referenceFiles) {
      if (file.id in sketchComments) {
        for (var c of sketchComments[file.id]) indexArray.push(parseInt(c.index))
      }
    }
    var index = 1
    while (indexArray.includes(index)) {
      index += 1
    }
    return index
  }

  //console.log('referenceFiles', referenceFiles)
  var indexImgWidth = 183
  //console.log('indexHtmlRef.current', indexHtmlRef.current?.clientWidth, indexImgWidth)
  return (
    <Card className="h-fit">
      <div className="min-w-full flex">
        <Card className="overflow-hidden" sx={{ width: "200px", minWidth: "200px" }}>
          <div ref={indexHtmlRef} className="pl-1 py-1">
            <SuiBox sx={{ my: 1 }} className="flex items-center justify-center">
              <Upload
                accept='image/*'
                multiple
                showUploadList={false}
                customRequest={handleUpload}
              >
                <SuiButton sx={{ mx: 1, p: 0 }} size="medium" variant="text" color="dark" startIcon={<UploadIcon fontSize="large" />}>Upload Images
                </SuiButton>
              </Upload>
            </SuiBox>
            <ul className="overflow-y-auto overflow-x-hidden min-h-[60vh] max-h-[80vh]">
              <DragDropContext onDragEnd={handleDrop}>
                <Droppable droppableId="column-container" direction="vertical" >
                  {(provided) => (
                    <div
                      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      onClick={(e) => { e.stopPropagation(); }}
                    >
                      {referenceFiles.map((file, index) => (
                        <Draggable id={file.id} key={file.id} draggableId={file.id} index={index} >
                          {(provided) => {
                            provided.draggableProps.style = { ...provided.draggableProps.style, width: "100%" }
                            var width = file.rotation == 1 || file.rotation == 3 ? file.width / file.height * indexImgWidth : indexImgWidth
                            var height = file.rotation == 1 || file.rotation == 3 ? indexImgWidth : file.height / file.width * indexImgWidth
                            var imgstyle = {}
                            if (file.rotation === 1) {
                              [width, height] = [height, width];
                              imgstyle = { width: height, height: width, transform: "rotate(90deg) translateY(-100%)", transformOrigin: "top left" }
                            } else if (file.rotation === 2) {
                              imgstyle = { width: width, height: height, transform: "rotate(180deg) translateY(-100%) translateX(-100%)", transformOrigin: "top left" }
                            } else if (file.rotation === 3) {
                              [width, height] = [height, width];
                              imgstyle = { width: height, height: width, transform: "rotate(270deg) translateX(-100%)", transformOrigin: "top left" }
                            } else {
                              imgstyle = { width: width, height: height }
                            }
                            return <div
                              ref={provided.innerRef}
                              {...provided.dragHandleProps}
                              {...provided.draggableProps}
                            >
                              <SuiBox sx={{ my: 1, width: width + 4, height: height + 4, border: "1px solid lightgray" }} onClick={() => { setCurrentFile(file) }}>
                                <img src={file.imgurl[0]} style={imgstyle} />
                              </SuiBox>
                            </div>
                          }}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </ul>
          </div>
        </Card>
        <Card className="w-full h-fit ml-2">
          <FileBoard detail={detail} currentFile={currentFile} setCurrentFile={setCurrentFile} referenceFiles={referenceFiles} setReferenceFiles={setReferenceFiles} commentsList={sketchComments[currentFile?.id] ?? []} projectid={projectid} editable={editable} refreshComments={refreshComments} getNextIndex={getNextIndex} account={account} />
        </Card>
      </div >
    </Card >
  );
};

export default ReferencesStage;
